import React, { useState } from 'react';
import { css } from 'aphrodite/no-important';
import { Button, Tag, MessageMood } from '@trainline/depot-web';
import { FormattedMessage, useIntl } from 'react-intl';

import Menu from '@contactcentre-web/common/Menu';

import BlockAccount from './BlockAccount';
import UnblockAccount from './UnblockAccount';
import styles from './styles';
import messages from './messages';

// @TODO add status as a prop with either Active | Blocked
// Might need to ping Product to check if blocked reason should be included

export enum BlockReason {
  PaymentFailed = 'PaymentFailed',
  FraudThresholdExceeded = 'FraudThresholdExceeded',
}

const ProfileStatus = () => {
  const intl = useIntl();
  const [showManageAccountModal, setManageBlockAccountModal] = useState(false);
  const [accountBlockedReason, setAccountBlockedReason] = useState<BlockReason | null>(null);
  return (
    <div className={css(styles.profileStatusContainer)}>
      <div className={css(styles.statusContainer)}>
        <div className={css(styles.statusTitle)}>
          <FormattedMessage {...messages.account} />
          :&nbsp;
        </div>
        <Tag
          typeStyle="small"
          label={
            accountBlockedReason
              ? intl.formatMessage(messages.blocked)
              : intl.formatMessage(messages.active)
          }
          mood={accountBlockedReason ? MessageMood.NEGATIVE : MessageMood.POSITIVE}
        />
      </div>
      <div>
        <Menu
          handle={<Button text="..." size="small" buttonType="tertiary" />}
          items={[
            {
              handle: (
                <div className={css(styles.menuItem)}>
                  <FormattedMessage
                    {...(accountBlockedReason ? messages.unblockAccount : messages.blockAccount)}
                  />
                </div>
              ),
              onClick: () => setManageBlockAccountModal(true),
            },
            {
              handle: (
                <div className={css(styles.menuItem)}>
                  <FormattedMessage {...messages.emailDispute} />
                </div>
              ),
              onClick: () => alert('Email dispute instructions clicked'),
            },
          ]}
        />
      </div>
      <BlockAccount
        visible={showManageAccountModal && accountBlockedReason === null}
        onClose={() => setManageBlockAccountModal(false)}
        blockAccount={(reason: BlockReason) => setAccountBlockedReason(reason)}
      />
      <UnblockAccount
        visible={showManageAccountModal && accountBlockedReason !== null}
        onClose={() => setManageBlockAccountModal(false)}
        blockReason={accountBlockedReason}
        unblock={() => setAccountBlockedReason(null)}
      />
    </div>
  );
};

export default ProfileStatus;
